// extracted by mini-css-extract-plugin
export default {"priceListUerWorkScopesModal":"PriceListUerWorkScopesModal_priceListUerWorkScopesModal__UmJCq"};